import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "browse-catalog-layout" }
const _hoisted_2 = { class: "search-info-label" }
const _hoisted_3 = { class: "browse-catalog-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_button = _resolveComponent("link-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.localize('ShowAllSparePartsInfo')) + ":", 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_link_button, {
        caption: _ctx.localize('AllSpareParts'),
        "route-name": "sparepartCatalog"
      }, null, 8, ["caption"])
    ])
  ]))
}